import React, { useState } from "react";
import { Typography, Grid, TextField, Box, Chip, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useFormikContext } from "formik";
import ReusableDialog from "../../../../common/dialog/dialog";

const DistinguishingFeatures = ({ setFeatures }) => {
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext();
  const [openFeature, setFeatureOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null); // Initialize with null to indicate no selection at the start
  const [toggle, setToggle] = useState("no");
  const hours = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, "0")}:00`);

  const handleTimeSelect = (time) => {
    setSelectedTime(time); // Set the selected time directly
  };

  const handleToggle = (event, newToggle) => {
    if (newToggle !== null) {
      setToggle(newToggle);
      if (newToggle === "no") {
        setSelectedTime(null); // Clear selected time if toggle is "no"
        setFeatures(null); // Clear feature if toggle is "no"
      }
      setFeatureOpen(newToggle === "yes");
    }
  };

  // Handler for adding a new feature (selected time)
  const handleAddFeatures = () => {
    setFeatures(selectedTime);
    setFeatureOpen(false); // Close the dialog after adding the time
  };

  return (
    <>
      <Typography sx={{ fontSize: "18px", color: "black" }} mt={5}>
        Distinguishing Features
      </Typography>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Hair Colour
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Hair Colour'
            name='hairColour'
            value={values.hairColour}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.hairColour && Boolean(errors.hairColour)}
            helperText={touched.hairColour && errors.hairColour}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Eye Colour
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Eye Colour'
            name='eyeColour'
            value={values.eyeColour}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.eyeColour && Boolean(errors.eyeColour)}
            helperText={touched.eyeColour && errors.eyeColour}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Build
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter Build'
            name='build'
            value={values.build}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.build && Boolean(errors.build)}
            helperText={touched.build && errors.build}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} mt={1}>
        <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
          Marks/Scars
        </Typography>
        <TextField
          fullWidth
          name='marks'
          value={values.marks}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.marks && Boolean(errors.marks)}
          helperText={touched.marks && errors.marks}
          multiline
          rows={2}
        />
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={10}>
          <Grid container spacing={2}>
            <Grid item xs={6} lg={11}>
              <Typography sx={{ fontSize: "14px", color: "black" }} align='left' mb={2}>
                In the event of a young person missing from home, the parents should be notified
              </Typography>
            </Grid>
            <Grid item xs={6} lg={1}>
              <Grid container alignItems='center' mb={1}>
                <ToggleButtonGroup
                  color='primary'
                  value={toggle}
                  exclusive
                  onChange={(event, newToggle) => {
                    handleToggle(event, newToggle);
                  }}
                  aria-label='yes no toggle'
                >
                  <ToggleButton value='yes' aria-label='Yes'>
                    Yes
                  </ToggleButton>
                  <ToggleButton value='no' aria-label='No'>
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>
          </Grid>

          {selectedTime && toggle === "yes" && (
            <Grid item>
              <Chip color='info' label={selectedTime} />
            </Grid>
          )}

          {/* Dialog for Adding New Professional */}
          <ReusableDialog
            isOpen={openFeature}
            onClose={() => setFeatureOpen(false)}
            title='Add another professional person?'
            contentText='Add the relevant details to the fields to add another person to the involved parties.'
            onSubmit={handleAddFeatures}
            submitText='Add'
            cancelText='Cancel'
            disable={!selectedTime}
          >
            <Box mt={2}>
              <Grid container spacing={1} justifyContent='center'>
                {hours.map((time) => (
                  <Grid item key={time}>
                    <Chip
                      label={time}
                      clickable
                      color={time === selectedTime ? "primary" : "default"}
                      onClick={() => handleTimeSelect(time)}
                      sx={{
                        width: 300,
                        textAlign: "center",
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </ReusableDialog>
        </Grid>
      </Grid>
    </>
  );
};

export default DistinguishingFeatures;
